import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TileService } from '../../../widgets/services/tile.service';
import { CKEditorModule } from 'ckeditor4-angular';


@Component({
  selector: 'app-create-word-of-the-week',
  standalone: true,
  imports: [FormsModule, CommonModule, CKEditorModule],
  templateUrl: './page-create-word-of-the-week.component.html',
  styleUrls: ['./page-create-word-of-the-week.component.scss']
})
export class PageCreateWordOfTheWeekComponent {
  title!: string;
  uploadDataForm: FormGroup;
  smartBankColour: any = '#03abba';
  constructor(private router: Router, private service: TileService, private http: HttpClient, private formBuilder: FormBuilder) {
    //this.smartBankModel.fileName = "";
    this.title = "Word of the Week";

    this.uploadDataForm = this.formBuilder.group({
      tip: new FormControl(null),
      tipName: new FormControl(null),
    });
    const navigation = this.router.getCurrentNavigation();
    const state = navigation?.extras.state as {
      isEdit: boolean,
      editId: string
      startDate: string,
      word: string,
      details: string,
    };
    if (state) {
      this.wordOftheWeekId = state.editId;
      if (this.wordOftheWeekId != '') {
        var date = new Date(state.startDate);
        date.setDate(date.getDate() + 1);
        this.startDate = new Date(date.toString()).toISOString().slice(0, 10);
      }
      else {
        this.startDate = state.startDate;

      }
      this.word = state.word;
      this.details = state.details;
    }
    
  }


  travelEmission: string = "";
  treesRequired: string = "";

  startDate: string = '';
  word: any;
  details: any;
  validateWordOfTheWeek() {
    var errorMessage = "";
    // Validate Date
    if (this.startDate.toString() === "") {
      errorMessage += "    Start Date.\n";
    }
    // Validate Word
    if (this.word === "") {
      errorMessage += "    Word\n";
    }
    // Validate Details
    if (this.details === "") {
      errorMessage += "    Details\n";
    }
    if (errorMessage.length > 0) {
      alert("The following fields are required;\n" + errorMessage);
    }
    else {
      this.validateStartDate();
    }
  }
  async validateStartDate() {
    var model = {
      "id": this.wordOftheWeekId,
      "startDate": this.startDate
    };
    if (this.wordOftheWeekId != "") {
      this.service.validateStartDate(model).then((data) => {
        if (data == true) {
          this.updateWordOfTheWeek({ id: this.wordOftheWeekId, startDate: this.startDate, word: this.word, details: this.details });
        }
        else {
          alert("Start date must be unique!");
        }
      });
    }
    else {
      this.saveWordOfTheWeek({ word: this.word, details: this.details, startDate: this.startDate }).then((data) => { });
    }
  }
  async updateWordOfTheWeek(model: any) {
    this.service.updateWordOfTheWeek(model).then((data) => {
      this.router.navigate(["wordoftheweek/curation"]);
    });
  }
  wordOftheWeekId: string = "";
  async saveWordOfTheWeek(model: any) {

    this.service.saveWordOfTheWeek(model).then((data) => {
      this.router.navigate(["wordoftheweek/curation"]);
    })
  }
  ckEditorConfig: any = {
    toolbar: [
      ['Bold', 'Italic', 'Underline', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', 'NumberedList', 'BulletedList', 'Link', 'Unlink', 'Table', 'Font', 'FontSize', 'TextColor', 'BGColor', 'Image',],
    ]
  };
  onCkEditorReady(event: any) {


  }
  cancel() {
    this.router.navigate(["wordoftheweek/curation"]);
  }
}




